"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomMenuItem = void 0;

var _find2 = _interopRequireDefault(require("lodash/find"));

var _reactQuery = require("react-query");

var _types = require("../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useCustomMenuItem = function useCustomMenuItem() {
  var _a;

  var queryClient = (0, _reactQuery.useQueryClient)();
  var menu = queryClient.getQueryData("Menu"
  /* Menu */
  );
  var menuType = menu && (0, _find2["default"])(menu.menuTypes, function (item) {
    return item.itemType === _types.CustomPizza.CustomPizzaCode;
  });
  return (_a = menuType === null || menuType === void 0 ? void 0 : menuType.menuItems) === null || _a === void 0 ? void 0 : _a[0];
};

exports.useCustomMenuItem = useCustomMenuItem;